"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDITOR_BANNER_BLOCK_IDX = exports.EDITOR_FLOATING_BUTTON_BLOCK_IDX = exports.EDITOR_SHOPPABLE_VIDEO_BLOCK_IDX = exports.PREVIEW_HOSTNAME = exports.DESKTOP_PARAM = exports.NO_PREVIEW_BANNER_PARAM = exports.IS_EDITOR_PREVIEW_PARAM = exports.EnrichmentMode = exports.NO_PIXELS_PARAM = exports.IS_PREVIEW_PARAM = exports.PRODUCT_FAMILIES_PARAM = void 0;
exports.isProductFamiliesQueryEnabled = isProductFamiliesQueryEnabled;
// Query params used to suppress shopper-side side effects (analytics pixels,
// redirects) when a storefront is rendered inside the editor or a preview.
exports.PRODUCT_FAMILIES_PARAM = 'siblings';
function isProductFamiliesQueryEnabled(query) {
    if (query == null)
        return false;
    let raw;
    if (typeof query === 'string') {
        const search = query.startsWith('?') ? query.slice(1) : query;
        raw = new URLSearchParams(search).get(exports.PRODUCT_FAMILIES_PARAM);
    }
    else if (query instanceof URLSearchParams) {
        raw = query.get(exports.PRODUCT_FAMILIES_PARAM);
    }
    else {
        raw = query[exports.PRODUCT_FAMILIES_PARAM];
    }
    const value = Array.isArray(raw) ? raw[0] : raw;
    return value === '1' || value === 'true';
}
exports.IS_PREVIEW_PARAM = 'is-preview';
exports.NO_PIXELS_PARAM = 'no-pixels';
var EnrichmentMode;
(function (EnrichmentMode) {
    EnrichmentMode["SLIM"] = "slim";
    EnrichmentMode["CARD"] = "card";
    EnrichmentMode["FULL"] = "full";
})(EnrichmentMode || (exports.EnrichmentMode = EnrichmentMode = {}));
exports.IS_EDITOR_PREVIEW_PARAM = 'is-editor-preview';
// Hides the Preview Mode banner without otherwise changing preview behavior.
// Used by the review screenshot so the LLM sees the page, not the overlay.
exports.NO_PREVIEW_BANNER_PARAM = 'no-preview-banner';
// Suppresses the configured desktop redirect so a brand that sends desktop
// traffic to its own site can still open its storefront's desktop layout.
// Unlike the other params here it leaves pixels alone: the visit is real.
exports.DESKTOP_PARAM = 'desktop';
// Hostname treated as "in preview" when no is-preview param is present.
exports.PREVIEW_HOSTNAME = 'shop.blackcrow.ai';
/** Admin editor `selectedBlockIdx` for scrolling the preview to the shoppable video hero. */
exports.EDITOR_SHOPPABLE_VIDEO_BLOCK_IDX = -1;
/** Admin editor `selectedBlockIdx` for scrolling the preview to the floating CTA footer. */
exports.EDITOR_FLOATING_BUTTON_BLOCK_IDX = -2;
/** Admin editor `selectedBlockIdx` for scrolling the preview to the promotional banner header. */
exports.EDITOR_BANNER_BLOCK_IDX = -3;
